export default {
  RemoveItemGroup: 'گروه اقلام حذف شد',
  RemoveItemFeature: 'ویژگی اقلام حذف شد',
  NewItemGroupAdd: 'گروه اقلام جدید اضافه شد',
  ItemGroupUpdate: 'گروه اقلام بروزرسانی شد ',
  NewItemAdd: 'یک قلم کالا اضافه شد',
  ItemUpdate: 'یک قلم کالا بروزرسانی شد',
  ItemFeatureUpdate: 'ویژگی اقلام بروزرسانی',
  NewItemFeatureAdd: 'ویژگی اقلام جدید اضافه شد',

  Information: 'اطلاعات',  
  Image: 'عکس',
  Feature: 'ویژگی',
  Dimension: 'اندازه',
  Interval: 'بازه ای',
  DimensionItem: 'واحد اقلام',
  Size: 'اندازه',
  Enable: 'فعال',
  Disable: 'غیر فعال',
  FloorSensitive: 'اقلام حساس',
  Order: 'ترتیب',
  HeightThreshold: 'بازه قد',
  Length: 'طول',
  LengthThreshold: 'بازه طول',
  Width: 'عرض',
  WidthThreshold: 'بازه عرض',
  Weight: 'وزن',
  Amount: 'میزان',
  Height: 'قد',
  Item: 'اقلام',
  Others: 'سایر',
  NoThreshold: 'عدم بازه',
  Threshold: 'بازه',
  Unit: 'واحد',
  Slug: 'Slug',
  ItemGroup: 'گروه اقلام',
  Description: 'توضیحات',
  WeightThreshold: 'بازه وزن'
}